module.exports = __webpack_public_path__ + "static/media/icon-event__revolucion-del-68.ff8a36e3.svg";